module.exports = __webpack_public_path__ + "static/media/img_offlineOnClick.13f71d23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_offlineOnClick.jpg
// module id = 427
// module chunks = 4